import { LANGUAGE, LANGUAGE_STORAGE_KEY } from '../constants';
import { getLanguageCode } from './language';

export const BOKAMERA_SITEPATH = 'bokamera';
export const EMBED_COMPANY_ID = '08b32c4f-9ca9-449b-8c69-85773ac2093c';
export const PRIMARY_COLOR = '#6a35a3';

export const MODAL_TOP_OFFSET = { desktop: 0, mobile: 0 };

const WIDGET_LAYOUT = {
  bookLayout: 'time-based',
  listingLayout: 'rows',
  timesLayout: 'day',
  showTimeSlotsOnExpand: false,
  showStepper: { mobile: false, desktop: false },
  checkoutInfoLayout: { mobile: 'compact', desktop: 'compact' },
  stickyNavigation: false,
};

const readStoredLanguage = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const getWidgetLanguage = () => getLanguageCode(readStoredLanguage() || LANGUAGE);

export const buildWidgetConfiguration = ({
  language,
  serviceIdsToShow,
  selectedService,
  topOffset,
  layoutOverrides = {},
  themeOverrides = {},
}) => ({
  version: 'v8',
  company: EMBED_COMPANY_ID,
  language,
  theme: {
    ...themeOverrides,
    light: { primaryColor: PRIMARY_COLOR, ...themeOverrides.light },
  },
  layout: { ...WIDGET_LAYOUT, ...layoutOverrides, topOffset },
  behavior: {
    bookMethods: ['contact-information'],
    showSubscribeToNewsletter: false,
    showNextAvailableTime: true,
    bookingFlow: 'legacy',
  },
  preselection: {
    ...(serviceIdsToShow ? { serviceIdsToShow } : {}),
    ...(selectedService ? { selectedService } : {}),
  },
});
